<template>
  <div>
    <div class="border-ontick-steel-300 dark:border-ontick-graphite-500 overflow-y-auto rounded-lg border-b shadow">
      <table
        id="tabela_pnl"
        class="divide-ontick-steel-300 dark:divide-ontick-carbon-500 min-w-full table-fixed divide-y"
      >
        <thead class="bg-ontick-graphite-500">
          <tr>
            <th class="w-6 !px-4">&nbsp;</th>
            <th class="!px-2 md:!px-0">Data</th>
            <th class="!px-4 md:!px-0">Operação</th>
            <th class="!px-2 md:!px-0">Volume</th>
            <th class="!px-2 md:!px-0">Entrada</th>
            <th class="!px-2 md:!px-0">Saída</th>
            <th class="!px-2 md:!px-0">Resultado</th>
            <th class="w-6">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="data.msg">
            <tr>
              <td colspan="8">
                <p class="px-4 py-2 text-center">{{ data.msg }}</p>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr v-for="(item, index) in data.positions_list" :key="index">
              <td class="!px-4">
                <span
                  v-if="item.position_origin === 'PT'"
                  class="block h-2 w-2 rounded-sm bg-[#057BBF80] shadow"
                ></span>
                <span v-else class="block h-2 w-2 rounded-sm bg-[#B9AB3066] shadow"></span>
              </td>
              <!-- <td>12/08/2024 13:12:47</td> -->
              <td class="!px-2 md:!px-0">
                <span v-if="item.position_origin === 'PT'">{{
                  moment(item.position_time_open).format("DD/MM/YYYY HH:mm:ss")
                }}</span>
                <span v-else>{{ moment(item.datetime).format("DD/MM/YYYY HH:mm:ss") }}</span>
              </td>
              <td class="space-x-1.5 !px-4 md:!px-0">
                <template v-if="item.position_origin === 'PT'">
                  <span class="bg-ontick-blue-900 rounded px-2 py-0.5 text-xs font-medium text-gray-50 shadow">{{
                    item.position_symbol
                  }}</span>
                  <span
                    class="bg-ontick-yellow-800 text-ontick-graphite-500 rounded py-0.5 px-2 text-xs font-bold uppercase shadow"
                    >{{ item.position_type === "BUY" ? "C" : "V" }}</span
                  >
                </template>
                <span v-else class="text-gray-500 font-medium">-</span>
              </td>
              <td class="!px-2 md:!px-0">
                <span v-if="item.position_origin === 'PT'">{{ item.position_volume }}</span>
                <span v-else class="text-gray-500 font-medium">-</span>
              </td>
              <td class="!px-2 md:!px-0">
                <span v-if="item.position_origin === 'PT'">
                  {{ moneyFormatterModal(item.position_price_avg) }}
                </span>
                <span v-else class="text-gray-500 font-medium">-</span>
              </td>
              <td class="!px-2 md:!px-0">
                <span v-if="item.position_origin === 'PT'">
                  {{ moneyFormatterModal(item.position_price_current) }}
                </span>
                <span v-else class="text-gray-500 font-medium">-</span>
              </td>
              <td
                class="!px-2 md:!px-0"
                :class="moneyColor(item.position_origin === 'PT' ? item.position_profit : item.pnl)"
              >
                <span v-if="item.position_origin === 'PT'">
                  {{ moneyFormatter(item.position_profit) }}
                </span>
                <span v-else>
                  {{ moneyFormatter(item.pnl) }}
                </span>
              </td>
              <td class="!px-4">
                <button @click="isPapertrade(item) ? getOrder(item.position_uuid) : null">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="ml-auto"
                  >
                    <path
                      d="M4.34792 13.6062H10.65V12.2312H4.34792V13.6062ZM4.34792 9.6875H13.6521V8.3125H4.34792V9.6875ZM4.34792 5.76875H13.6521V4.39375H4.34792V5.76875ZM2.125 17.25C1.75833 17.25 1.4375 17.1125 1.1625 16.8375C0.8875 16.5625 0.75 16.2417 0.75 15.875V2.125C0.75 1.75833 0.8875 1.4375 1.1625 1.1625C1.4375 0.8875 1.75833 0.75 2.125 0.75H15.875C16.2417 0.75 16.5625 0.8875 16.8375 1.1625C17.1125 1.4375 17.25 1.75833 17.25 2.125V15.875C17.25 16.2417 17.1125 16.5625 16.8375 16.8375C16.5625 17.1125 16.2417 17.25 15.875 17.25H2.125ZM2.125 15.875H15.875V2.125H2.125V15.875ZM2.125 2.125V15.875V2.125Z"
                      :fill="isPapertrade(item) ? '#0694E6' : '#737373'"
                    />
                  </svg>
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <section v-show="data.positions_list" class="legend mt-6 flex items-start justify-between">
      <div class="flex flex-col space-y-1 space-x-0 md:flex-row md:space-y-0 md:space-x-6">
        <p class="inline-flex items-center space-x-1.5">
          <span class="block h-3 w-3 rounded-sm bg-[#B9AB3066]"></span>
          <span class="text-xs font-semibold">Backtest</span>
        </p>
        <p class="inline-flex items-center space-x-1.5">
          <span class="block h-3 w-3 rounded-sm bg-[#057BBF80]"></span>
          <span class="text-xs font-semibold">Paper trade</span>
        </p>
      </div>
      <div class="flex-col space-y-1 lg:flex-row lg:space-y-0 lg:space-x-6">
        <pagination-component
          :totalPage="data.max_page"
          :currentPage="currentPage"
          @changePage="($event) => $emit('changePage', $event)"
        />
      </div>
    </section>
    <portal to="modal">
      <ontick-modal-component :open="isOpenModal" @close="isOpenModal = false" size="small">
        <h1 class="text-2xl font-bold text-gray-50">Ordens</h1>
        <div
          class="border-ontick-steel-300 dark:border-ontick-graphite-500 my-3 overflow-x-auto overflow-y-auto rounded-lg border-b shadow"
        >
          <table
            class="divide-ontick-steel-300 dark:divide-ontick-carbon-500 min-w-full table-fixed divide-y"
            id="modal"
          >
            <!-- <thead class="bg-ontick-steel-200 dark:bg-ontick-steel-500"> -->
            <thead class="bg-ontick-steel-600">
              <tr>
                <th>Data</th>
                <th>Status</th>
                <th>Sentido</th>
                <th>Ordem</th>
                <th>Volume</th>
                <th>Preço</th>
                <th>Resultado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in dataModal" :key="index">
                <td>
                  {{ moment(item.order_time_done).format("DD/MM/YYYY HH:mm:ss") }}
                </td>
                <td class="space-x-1.5">
                  <!-- <span
                    class="shadow bg-ontick-blue-900 text-gray-50 rounded px-2 py-0.5 text-xs font-medium"
                    >WINFUT</span
                  > -->
                  <span
                    v-if="item.order_state === 'F'"
                    :content="item.order_state_tooltip"
                    v-tippy="{ arrow: true, theme: 'lime' }"
                    class="bg-ontick-lime-900 text-ontick-lime-400 rounded py-0.5 px-2 text-xs font-bold uppercase shadow"
                    >F</span
                  >
                  <span
                    v-else
                    class="bg-ontick-orange-900 text-ontick-orange-300 rounded py-0.5 px-2 text-xs font-medium uppercase shadow"
                    >C</span
                  >
                </td>
                <td>{{ item.order_goal === "EXIT" ? "SAÍDA" : "ENTRADA" }}</td>
                <td>
                  <span
                    :content="item.order_type_tooltip"
                    v-tippy="{ arrow: true, theme: 'prussian' }"
                    class="bg-ontick-prussian-400 text-ontick-prussian-50 rounded py-0.5 px-2 text-xs font-medium uppercase shadow"
                    >{{ item.order_type }}</span
                  >
                </td>
                <td class="space-x-1.5">
                  <span
                    :content="item.order_direction"
                    v-tippy="{ arrow: true, theme: 'yellow-800' }"
                    class="bg-ontick-yellow-800 text-ontick-graphite-500 rounded py-0.5 px-2 text-xs font-bold uppercase shadow"
                    >{{ item.order_direction.toUpperCase() === "COMPRA" ? "C" : "V" }}</span
                  >
                  <span>{{ item.order_volume }}</span>
                </td>
                <td>
                  {{ moneyFormatter(item.order_price) }}
                </td>
                <td>
                  <div v-if="item.order_goal === 'EXIT'" class="flex items-center space-x-1.5">
                    <svg
                      width="10"
                      height="8"
                      viewBox="0 0 10 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      :class="item.order_profit > 0 ? 'rotate-0' : 'rotate-180'"
                    >
                      <path d="M10 7.75L0 7.75L5 0.25L10 7.75Z" :fill="item.order_profit > 0 ? '#1EB866' : '#dd5b5b'" />
                    </svg>
                    <span>{{ moneyFormatterModal(item.order_profit) }}</span>
                  </div>
                  <span v-else class="text-gray-500 font-medium">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ontick-modal-component>
    </portal>
  </div>
</template>

<script>
import OntickModalComponent from "../../../../shared/components/basic/ontick-modal.component.vue";
import PaginationComponent from "./pagination.component.vue";

export default {
  name: "marketplace-table-operation",
  components: {
    OntickModalComponent,
    PaginationComponent,
  },
  props: {
    data: {
      type: Object,
      default: [],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isOpenModal: false,
      dataModal: [],
    };
  },
  methods: {
    isPapertrade(item) {
      // Object(item).hasOwnProperty("position_uuid")
      return item.position_origin === "PT";
    },
    getOrder(position_uuid) {
      this.$api
        .get(`${this.$endpoint.GET_STRATEGIES_ORDER_V2}/${position_uuid}`)
        .then((res) => {
          this.dataModal = res.data;
          this.isOpenModal = true;
        })
        .catch((error) => {
          this.dataModal = [];
        });
    },
    moneyFormatter(amount = 0) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        signDisplay: "always",
      }).format(amount);
    },
    moneyFormatterModal(amount = 0) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(amount);
    },
    moneyColor(amount) {
      if (amount >= 0) return "dark:text-ontick-green-600 text-ontick-green-800";
      else if (amount < 0) return "dark:text-ontick-red-600 text-ontick-red-900";
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
table thead tr th {
  @apply text-ontick-carbon-900 px-0 py-2 text-left text-sm font-medium tracking-wider dark:text-gray-300;
}
table tbody {
  // @apply divide-y divide-ontick-steel-300 bg-gray-50 text-left dark:divide-ontick-carbon-500 dark:bg-ontick-graphite-500;
  @apply dark:bg-ontick-graphite-500 bg-gray-50 text-left;
  tr {
    @apply odd:bg-ontick-steel-500 even:bg-[#202A3780];
    td {
      @apply px-0 py-2 text-sm;
    }
  }
}
table#modal thead tr th {
  @apply text-ontick-carbon-900 py-2 pl-4 pr-2 text-left text-sm font-medium tracking-wider dark:text-gray-300;
}
table#modal tbody {
  @apply divide-ontick-steel-300 dark:divide-ontick-carbon-500 dark:bg-ontick-steel-500 divide-y bg-gray-50 text-left;
  @apply dark:bg-ontick-graphite-500 bg-gray-50 text-left;
  tr {
    @apply bg-ontick-steel-500;
    td {
      @apply whitespace-nowrap py-2 pl-4 pr-2 text-sm;
    }
  }
}
</style>
